interface InputButton {
    key: string;
    value: string;
}

interface InputButtonsProps {
    labels: InputButton[];
    onAdd: (key: string, type: string) => void;
}
const InputButtons: React.FC<InputButtonsProps> = ({ labels, onAdd }) => {
    return (
        <div className='flex items-center flex-wrap gap-s mt-4'>
            {labels.map((label, index) => (
                <button
                    key={index}
                    className="text-xs text-center bg-white rounded-md focus:ring-2 border px-1 py-1 mr-2 mt-2 hover:bg-gray-200 focus:outline-none active:bg-sky-100 focus:border-blue-300 transition-colors duration-200"
                    onClick={() => onAdd(label?.key, label.value)}
                >
                    {label.value}
                </button>
            ))}
        </div>
    );
};

export default InputButtons;
